import { Trans, useLingui } from "@lingui/react/macro"
import React from "react"

import Paragraph from "../../../../design-system/paragraph"
import UniversalLink from "../../../../design-system/universal-link"
import OptimizedImage from "../../../optimized-image"
import TremendousLogo from "../../../tremendous-logo"
import Socials from "../socials"
import * as styles from "./index.module.scss"

const LogoSection = () => {
  const { t } = useLingui()

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <TremendousLogo size="medium" color="white" />
        <Paragraph variant="2" className={styles.description}>
          <Trans>
            The simplest way for businesses to send rewards and payouts
          </Trans>
        </Paragraph>
      </div>
      <Socials className={styles.socialsContainer} />
      <UniversalLink
        to="https://www.g2.com/products/tremendous/reviews?utm_source=review-widget"
        title={t`Read reviews of Tremendous on G2`}
      >
        <OptimizedImage
          data-chromatic="ignore"
          height="74"
          width="148"
          alt={t`Read reviews of Tremendous on G2`}
          src="https://www.datocms-assets.com/85985/1725928611-g2-tremendous.png"
          preset="graphic"
        />
      </UniversalLink>
    </div>
  )
}

export default LogoSection
